import React, { useEffect } from 'react';
import { Table } from 'tdesign-react';
import useTable from '@/hooks/useTable';
import { renderByte, renderByteRate, renderDateTime, renderNumRate } from '@/utils/common';

export default function Producer({ data }) {
  const columns = [
    {
      colKey: 'producerId',
      title: '生产者ID',
      width: 100,
    },
    {
      colKey: 'producerName',
      title: '生产者名',
      width: 160,
    },
    {
      colKey: 'rateIn',
      title: '生产速率',
      cell: renderNumRate,
      width: 105,
    },
    {
      colKey: 'bytesIn',
      title: '生产吞吐',
      cell: renderByteRate,
      width: 105,
    },

    {
      colKey: 'avgSize',
      title: '平均大小',
      cell: renderByte,
      width: 105,
    },
    {
      colKey: 'clientVersion',
      title: '客户端版本',
      width: 120,
    },
    {
      colKey: 'address',
      title: '连接地址',
    },
    {
      colKey: 'connectedSince',
      title: '连接时间',
      cell: renderDateTime,
      width: 180,
    },
  ];

  const { config, setData } = useTable({ columns });

  useEffect(() => {
    setData(data);
  }, [data, setData]);

  return <Table style={{ marginTop: 16 }} {...config} />;
}
